module.exports = __webpack_public_path__ + "static/media/HowItWorkImage4.b17e1989.jpeg";